import { Outlet } from 'react-router-dom'
import TopHeader from './marketing-chrome/TopHeader'
import Navigation from './marketing-chrome/Navigation'
import Footer from './marketing-chrome/Footer'
import CookieConsent from './marketing-chrome/CookieConsent'

export default function MarketingLayout() {
  return (
    <div className="marketing-chrome min-h-screen bg-dark-1 flex flex-col">
      <TopHeader />
      <Navigation />
      <main className="flex-1 min-w-0">
        <Outlet />
      </main>
      <Footer />
      <CookieConsent />
    </div>
  )
}
